var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"textAreaField"},[_c('label',[_vm._v(_vm._s(_vm.label))]),_c('textarea',{staticClass:"inputTextArea",attrs:{"rows":"3"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('update:value', $event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }